/**
 *
 * Ellipsis
 *
 */

import React from 'react';

function Ellipsis({ children }) {
  return <span>...ELLIPSIS</span>;
}

Ellipsis.propTypes = {};

export default Ellipsis;



// WEBPACK FOOTER //
// ./src/components/whoa/Ellipsis.js